import { StickyAlertType } from '@/modules/alerts/models/sticky-alert-type';
import StickyAlertPropMap from '@/modules/alerts/models/sticky-alert-prop-map';
import StickyAlertAnswerMap from '@/modules/alerts/models/sticky-alert-answer-map';

export default class StickyAlert<T extends StickyAlertType> {
  stickyAlertType: T;

  props: StickyAlertPropMap[T];

  private readonly answerPromise: Promise<StickyAlertAnswerMap[T]>;

  private resolveAnswerPromise: (value: StickyAlertAnswerMap[T]) => void;

  constructor(stickyAlertType: T, props: StickyAlertPropMap[T]) {
    this.stickyAlertType = stickyAlertType;
    this.props = props;
    this.answerPromise = new Promise(resolve => {
      this.resolveAnswerPromise = resolve;
    });
  }

  provideAnswer(answer: StickyAlertAnswerMap[T]) {
    this.resolveAnswerPromise(answer);
  }

  async getAnswer(): Promise<StickyAlertAnswerMap[T]> {
    return this.answerPromise;
  }
}

export const alertIsOfType = <T extends StickyAlertType>(
  stickyAlertType: T,
  alert: StickyAlert<StickyAlertType>,
): alert is StickyAlert<T> => {
  return alert.stickyAlertType === stickyAlertType;
};
